import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CartItemData {
  id: string;
  item_type: 'service' | 'event' | 'gift_card' | 'course';
  item_id: string;
  title: string;
  price: number;
  quantity: number;
  image_url?: string;
  event_date?: string;
  metadata?: Record<string, unknown>;
}

interface CartStore {
  items: CartItemData[];
  addItem: (item: Omit<CartItemData, 'id'>) => void;
  removeItem: (id: string) => void;
  updateQuantity: (id: string, quantity: number) => void;
  clearCart: () => void;
  getTotal: () => number;
  getItemCount: () => number;
}

export const useCart = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (item) => {
        const id = `${item.item_type}-${item.item_id}-${Date.now()}`;
        set((state) => ({
          items: [...state.items, { ...item, id }]
        }));
      },
      
      removeItem: (id) => {
        set((state) => ({
          items: state.items.filter(item => item.id !== id)
        }));
      },
      
      updateQuantity: (id, quantity) => {
        if (quantity <= 0) {
          get().removeItem(id);
          return;
        }
        set((state) => ({
          items: state.items.map(item =>
            item.id === id ? { ...item, quantity } : item
          )
        }));
      },
      
      clearCart: () => set({ items: [] }),
      
      getTotal: () => {
        return get().items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      },
      
      getItemCount: () => {
        return get().items.reduce((sum, item) => sum + item.quantity, 0);
      }
    }),
    {
      name: 'karmaio-cart',
    }
  )
);